import { Card } from '@monash/portal-react';
import c from './link-tile-skeleton.module.scss';

const LOADING_BARS_COUNT = 4;

export const LinkTileSkeleton = ({ className }) => (
  <Card className={`${c.skeletonCard} ${className ?? ''}`}>
    <div aria-live="polite" data-testid="loading" className={c.content}>
      <div className={c.icon} />
      <div className={c.name} />
      <div className={c.description}>
        {Array(LOADING_BARS_COUNT)
          .fill('')
          .map((barPlaceholder, barIndex) => (
            <div className={c.bar} key={barIndex} />
          ))}
      </div>
    </div>
  </Card>
);
